class TableGridRadioCellController {
  constructor() {
    this.name = 'tableGridRadioCell';
  }

  isDisabled() {
    if(this.column.isDisabled) {
      return this.column.isDisabled(this.row);
    }
    return false;
  }
}

export
default TableGridRadioCellController;


// WEBPACK FOOTER //
// ./app/components/tableGridRadioCell/tableGridRadioCell.controller.js